export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_COMPANY_TOKEN = 'SET_COMPANY_TOKEN';
export const SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED =
  'SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED';
export const SET_COMPANY_IMAGE_PROTECTION_ENABLED =
  'SET_COMPANY_IMAGE_PROTECTION_ENABLED';
export const SET_COMPANY_IMAGE_PROTECTION_STYLE =
  'SET_COMPANY_IMAGE_PROTECTION_STYLE';

export function setCompanyName(name) {
  return {
    type: SET_COMPANY_NAME,
    payload: name,
  };
}

export function setCompanyToken(token) {
  return {
    type: SET_COMPANY_TOKEN,
    payload: token,
  };
}

export function setCompanyNonUsInternationalizationEnabled(enabled) {
  return {
    type: SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED,
    payload: !!enabled,
  };
}

export function setCompanyImageProtectionEnabled(enabled) {
  return {
    type: SET_COMPANY_IMAGE_PROTECTION_ENABLED,
    payload: !!enabled,
  };
}

export function setCompanyImageProtectionStyle(style) {
  return {
    type: SET_COMPANY_IMAGE_PROTECTION_STYLE,
    payload: style,
  };
}
